import { render, staticRenderFns } from "./quickView.vue?vue&type=template&id=71d1297e&scoped=true"
import script from "./quickView.vue?vue&type=script&lang=js"
export * from "./quickView.vue?vue&type=script&lang=js"
import style0 from "./quickView.vue?vue&type=style&index=0&id=71d1297e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d1297e",
  null
  
)

export default component.exports